module.exports = __webpack_public_path__ + "img/南阳市.c9297090.png";